<template>
    <div>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span style="line-height: 36px;">订单列表</span>

            <div style="float:right">
                <el-select v-model="searchSelect" slot="prepend" placeholder="请选择">
                  <el-option label="全部" value="ALL"></el-option>
                  <el-option label="待支付" value="WAITPAY"></el-option>
                  <el-option label="待发货" value="WAITDELIVER"></el-option>
                  <el-option label="待收货" value="WAITCONFIRM"></el-option>
                  <el-option label="已完成" value="SUCCESS"></el-option>
                </el-select>
                <el-button slot="append" icon="search" @click="btnQueryAccountByKey"></el-button>
            </div>
        </div>
        <div>
            <el-table
                v-loading="table_loading"
                element-loading-text="拼命加载中"
                :data="deviceData"
                stripe
                border
                fit
                height="520"
                @selection-change="handleSelectionChange"
                style="width: 100%">

                <el-table-column
                    prop="cpOrderId"
                    header-align="center"
                    min-width="250"
                    label="订单编号">
                </el-table-column>
                <el-table-column
                    prop="tradeTime"
                    header-align="center"
                    min-width="150"
                    label="下单时间">
                </el-table-column>
                <el-table-column
                    prop="userName"
                    header-align="center"
                    min-width="90"
                    label="下单用户">

                </el-table-column>
                <el-table-column
                    prop="totalPrice"
                    header-align="center"
                    min-width="80"
                    label="订单金额">
                </el-table-column>

                <el-table-column
                    prop="payTypeName"
                    header-align="center"
                    min-width="80"
                    label="支付方式">
                </el-table-column>
                <el-table-column
                    prop="tradeStatus"
                    header-align="center"
                    min-width="90"
                    label="订单状态">
                </el-table-column>

                <el-table-column
                    prop=""
                    header-align="center"
                    min-width="80"
                    label="操作">
                    <template scope="scope">
                   <el-button type="text" size="small"
            @click="tradeOrderDetail(scope.row.cpOrderId)">订单详情</el-button>
 <el-button type="text" size="small"
            @click="popUpdateDeviceCargoLane(scope.row.cpOrderId)" v-if="scope.row.tradeStatus=='待支付'">设为已支付</el-button>
                  </template>
                </el-table-column>
            </el-table>
        </div>

    <div class="table_pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
      </el-pagination>
    </div>
      </el-card>
      <po-add-pic :add-show="addPicShow" :cur-type="curType" @closeAddAccount="closeAddPic"></po-add-pic>
    </div>
</template>

<script>
import $axios from '../../https/config'
import poNewAddPic from '@/page/fxshop/fxTradeExpress'

export default {
  data () {
    return {
      pageSize: 10,
      pageNo: 1,
      table_loading: true,
      deviceData: [],
      pageTotal: 0,
      addPicShow: false,
      curType: 0,
      searchSelect: 'ALL',
      multipleSelection: ''
    }
  },
  created: function () {
    this.pageNo = 1
    this.queryTradeList(this.pageNo,this.pageSize,this.searchSelect)
  },
  methods: {
    queryTradeList (tPageNo, tPageSize,type) {
      var params = {
        pageNo: tPageNo,
        pageSize: tPageSize,
        type:type
      }
      this.table_loading = true
      this.deviceData = []
      var _this = this
      $axios.get('/order/queryListByOwner', params, 'headers', function (res) {
        if (res && res.resultStatus === true) {
          var resData = []
          if (res.resultData && res.resultData.list.length > 0) {
            _this.pageTotal = res.resultData.count
            for (var i = 0; i < res.resultData.list.length; i++) {
              var itemData = res.resultData.list[i]
              var tradeStatus
                  if (itemData.tradeStatus == 'WAITPAY') {
                    tradeStatus = '待支付'
                  } else if (itemData.tradeStatus == 'WAITDELIVER') {
                    tradeStatus = '待发货'
                  } else if (itemData.tradeStatus == 'WAITCONFIRM') {
                    tradeStatus = '待收货'
                  } else if (itemData.tradeStatus == 'SUCCESS') {
                    tradeStatus = '已完成'
                  }
              var payTypeName = "余额支付"
              if (itemData.payType==3){
                payTypeName = "易宝支付"
              }
              var item = {
                tradeId: itemData.tradeId,
                tradeTime: itemData.tradeTime,
                userName: itemData.userName,
                tradeStatus: tradeStatus,
                openId: itemData.openId,
                cpOrderId: itemData.cpOrderId,
                customAccount:itemData.customAccount,
                totalPrice: (itemData.totalPrice / 100).toFixed(2),
                payTypeName: payTypeName
              }
              resData.push(item)
            }
            _this.deviceData = resData
            _this.pageTotal = res.resultData.count
          }
        } else {
        }
        _this.table_loading = false
      })
    },
    btnQueryAccountByKey () {
          this.pageNo = 1
          if (this.searchSelect === 'ALL') {
            this.queryTradeList(this.pageNo, this.pageSize,'ALL')
          } else {
            this.queryTradeList(this.pageNo, this.pageSize,this.searchSelect)
          }
    },
    popUpdateDeviceCargoLane (cpOrderId) {
            var that = this
            var params = {
              cpOrderId: cpOrderId,
              tradeStatus: 'WAITDELIVER'
            }
            that.$confirm('修改订单状态为已支付？', '确认修改', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              $axios.post('/order/updateStatus', params, 'headers', function (res) {
                if (res && res.resultStatus === true) {
                  that.queryTradeList ()
                  that.$message({
                    type: 'success',
                    message: '修改订单状态成功!'
                  })
                  that.queryDeviceList()
                } else {
                  that.$message({
                    type: 'error',
                    message: '修改订单状态失败!'
                  })
                }
              })
            }).catch(() => {
              that.$message({
                type: 'info',
                message: '已取消'
              })
          })
      },
    handleSizeChange (val) {
      this.pageSize = val
      this.queryTradeList(this.pageNo, this.pageSize,this.searchSelect)
    },
    popTradeExpree (row) {
      //马上发货
      this.addPicShow = true
      this.curType = 2
      //this.row = row
      this.fxLevelObj = this.deviceData[row]

      console.log("before:"+JSON.stringify(this.fxLevelObj));
    },
    lookAcc (row) {
      this.addPicShow = true
    },
    handleCurrentChange (val) {
      this.pageNo = val
      this.queryTradeList(this.pageNo, this.pageSize,this.searchSelect)
    },
    handleSelectionChange (selection) {
      this.multipleSelection = ''
      for (var i = 0; i < selection.length; i++) {
        this.multipleSelection += (selection[i].code + '|')
      }
    },
    closeAddPic () {
      this.addPicShow = false
      this.pageNo = 1
      this.queryDeviceList()
    },
    tradeOrderDetail (row) {
        this.fxLevelObj = this.deviceData[row]
        console.log("before:"+row);
        //得到订单交易id查询详情tradeId
        this.$router.push({path: '/fxshop/fxTradeOrderDetail?cpOrderId='+row})
    },
    popRemovePic () {
      var that = this
      if (that.multipleSelection.length === 0) {
        that.$message({
          message: '请选择要回收的资源',
          type: 'info'
        })
        return false
      }
      var params = {
        adIds: that.multipleSelection
      }
      that.$confirm('您已选择广告的ID：' + that.multipleSelection, '是否删除选中的广告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        $axios.get('/device/delAdResources', params, 'headers', function (res) {
          if (res && res.resultStatus === true) {
            that.queryDeviceList()
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          } else {
          }
        }, function () {
          that.$message({
            type: 'error',
            message: '删除失败!'
          })
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  },
  components: {
    'po-add-pic': poNewAddPic
  }
}
</script>

<style>
    .table_pagination {
      text-align: right;
      margin-top: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/page/fxshop/fxTradeRecord.vue